import { createSlice } from '@reduxjs/toolkit';

import { getSessionId } from 'services/UserService';
import { getStorageData, setStorageData } from 'utils/storage/bottomBanner';

const initialState = getStorageData();

const bottomBannerSlice = createSlice({
  name: 'bottomBanner',
  initialState,
  reducers: {
    initialize: (state) => {
      const currentSessionId = getSessionId();

      if (initialState.sessionId !== currentSessionId) {
        if (!state.visible) state.visible = true;
        state.sessionId = currentSessionId;

        setStorageData(state);
      }
    },
    close: (state) => {
      state.visible = false;
      setStorageData({ ...getStorageData(), visible: false });
    },
  },
});

export const bottomBannerSelector = {
  getVisible: ({ bottomBanner }) => bottomBanner.visible,
};

export const { initialize, close } = bottomBannerSlice.actions;
export default bottomBannerSlice.reducer;
